{
  "slug": "processing-speed-games",
  "title": "Processing Speed Games",
  "description": "Train scanning and accurate response selection.",
  "category": "Brain training",
  "sections": [
    {
      "heading": "What to train",
      "paragraphs": [
        "Train scanning and accurate response selection.",
        "Specific practice transfers most strongly to similar tasks; broad-transfer claims need caution."
      ]
    },
    {
      "heading": "Exercises",
      "paragraphs": ["Increase difficulty only when accuracy is stable."],
      "bullets": [
        "Timed symbol matching",
        "Target cancellation grids",
        "Choice-reaction rounds",
        "Alternating letter-number sorting"
      ]
    },
    {
      "heading": "Sustainable routine",
      "paragraphs": [
        "Use brief regular sessions, adequate sleep, movement, and recovery.",
        "Track accuracy and difficulty rather than expecting a guaranteed IQ increase."
      ]
    }
  ],
  "related": ["can-iq-change-over-time", "working-memory-explained", "processing-speed-explained"],
  "sources": [],
  "faqs": [],
  "summary": "Train scanning and accurate response selection. Content reviewed 18 July 2026."
}
